import styled from "styled-components";

const SectionButton = styled.div`
    display: flex;
    align-items: center;
`;

export default SectionButton;
